import { useState } from 'react';

/**
 * Hook para manejar el estado de un modal de confirmación con loading.
 *
 * Centraliza el patrón: abrir con item → loading → cerrar/resetear
 * usado por los modales de inicio de OT y actividades.
 *
 * @returns {Object} Estado y acciones del modal
 * @returns {Object} returns.state - { open, item, loading }
 * @returns {Function} returns.open - Abre el modal con un item
 * @returns {Function} returns.close - Cierra el modal (bloqueado si loading)
 * @returns {Function} returns.setLoading - Activa/desactiva loading
 * @returns {Function} returns.reset - Cierra el modal incondicionalmente
 */
function useConfirmAction() {
  const [state, setState] = useState({ open: false, item: null, loading: false });

  const open = (item) => setState({ open: true, item, loading: false });
  const close = () => setState(prev => prev.loading ? prev : { open: false, item: null, loading: false });
  const setLoading = (val) => setState(prev => ({ ...prev, loading: val }));
  const reset = () => setState({ open: false, item: null, loading: false });

  return { state, open, close, setLoading, reset };
}

export default useConfirmAction;
